module.exports = __webpack_public_path__ + "img/head.9d4db3ef.png";